import { Box, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import { AverageCadenceCardData } from './averageCadenceCardData';
import { AverageCadencePanel } from './AverageCadencePanel';

interface AverageCadenceCardProps {
  data?: AverageCadenceCardData;
  onClick: (arg: string) => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  padding: '0px 0px 0px 16px !important',
}));

const AverageCadenceCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
}));

const PanelDisplayBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const AverageCadenceCard: React.FC<AverageCadenceCardProps> = ({
  data,
  onClick,
}: AverageCadenceCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      title={t('averageCadence.title')}
      iconName="AverageCadence"
      popoverContent={t('averageCadence.popover')}
      onClick={() => onClick('_10MWT')}
      enabled={!isEmpty(data)}
    >
      <CardDetailTypography>
        {t('averageCadence.description')}
      </CardDetailTypography>
      <AverageCadenceCardMedia>
        {data && data.value ? (
          <PanelDisplayBox>
            <AverageCadencePanel
              minValue={0}
              maxValue={200}
              range={[0, 100, 200]}
              value={data ? Number(data.value) : 0}
              unit={data ? data.unit : 'steps/min'}
            />
          </PanelDisplayBox>
        ) : null}
      </AverageCadenceCardMedia>
    </ParameterCard>
  );
};

export default AverageCadenceCard;
